export function createGeolocationService({ ttlMs = 5 * 60 * 1000 } = {}) {
  let cachedPos = null;
  let cacheTime = 0;

  function getCurrentPosition() {
    if (cachedPos && Date.now() - cacheTime < ttlMs) {
      return Promise.resolve(cachedPos);
    }

    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('non supporte'));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          cachedPos = pos;
          cacheTime = Date.now();
          resolve(pos);
        },
        reject,
        { timeout: 20000, enableHighAccuracy: false, maximumAge: 60000 }
      );
    });
  }

  return { getCurrentPosition };
}

// Message affiché quand le navigateur refuse la géolocalisation (code 1).
// Sur iPhone, le refus vient le plus souvent d'iOS lui-même (Service de
// localisation désactivé pour Safari/Chrome), pas d'un refus du site : on
// indique où régler, sinon l'utilisateur cherche dans le navigateur (cas
// réel, utilisateur au Canada sous Chrome iOS, 28 septembre 2026).
export function geolocDeniedMessage() {
  const ua = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isIOS) return 'Accès refusé — vérifie les paramètres de ton navigateur';
  const browser = /CriOS/.test(ua) ? 'Chrome'
    : /FxiOS/.test(ua) ? 'Firefox'
      : 'Sites web Safari';
  return `Accès refusé — sur iPhone : Réglages › Confidentialité et sécurité › Service de localisation › ${browser} › « Lorsque l’app est active », puis réessaie`;
}
